import React from 'react';
import { Grid } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import { useTheme } from '@material-ui/core/styles';

import { ScanField } from '../../form/fields';
import { ThumbIcon } from '../icons';
import { useLocale } from '../../hooks/useLocale/useLocale';

import { useStyles } from './ApproveAssetOwnerForm.styles';
import { ApproveAssetOwnerFormProps } from './ApproveAssetOwnerForm.types';

import { IconTile, StepContainer } from '..';

export const ApproveAssetOwnerForm = ({ goToNextStep, onSubmit, goToPreviousStep }: ApproveAssetOwnerFormProps) => {
  const { tileContainer, sendIcon, iconTileTitle, container } = useStyles();
  const { formatMessage } = useLocale();
  const { setValue } = useFormContext();
  const theme = useTheme();

  const handleSubmit = () => {
    onSubmit();
    goToNextStep();
  };

  return (
    <StepContainer title={formatMessage({ id: 'approve_asset_owner.details' })}>
      <Grid container spacing={1} className={container}>
        <Grid item xs={12}>
          <ScanField
            onScan={value => setValue('ownerAddress', value)}
            label={formatMessage({ id: 'approve_asset_owner.owner_address' })}
            name="ownerAddress"
          />
        </Grid>
      </Grid>
      <Grid container spacing={1} className={tileContainer}>
        <Grid container item xs={12} justify="center">
          <IconTile
            backgroundColor={theme.palette.secondary.main}
            color={theme.palette.text.primary}
            title={formatMessage({ id: 'approve_asset_owner.move_ownership' })}
            icon={<ThumbIcon classes={{ root: sendIcon }} />}
            onClick={handleSubmit}
            titleClassName={iconTileTitle}
          />
        </Grid>
      </Grid>
    </StepContainer>
  );
};
